import { kea } from "app/main/std";
import React = require("react");
import * as models from "app/models/requireme";
type Entity = models.BitacoraRADDto;

export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
* Modal de detalle
*/
export class DetalleModal extends React.PureComponent<Props> {
    value = (props: Props) => props.value;

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;

        return (
            <kea.Modal
                onClose={this.onCerrar}
                title="Detalle bitacora"
            >

                {kea.autogrid(2, [
                    <label><h4>Cliente :</h4> {value.NombreCliente}</label>,
                    <label><h4>Direccion :</h4> {value.DireccionDto.Descripcion}</label>,
                    <label><h4>Teléfono :</h4> {value.Telefono}</label>,
                    <label><h4>Nombre de quien solicita :</h4> {value.NombreQuienSolicita}</label>,
                    <label><h4>Observaciones :</h4> {value.Observaciones}</label>
                ])}
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/list/detalle.tsx